export const DEFAULT_CONTENT = {
  hero_overline: "Handgetöpferte Keramik · Made in Merzig",
  hero_line1: "Aus Erde",
  hero_line2_accent: "geformt",
  hero_line2_suffix: ", mit",
  hero_line3: "Händen erzählt.",
  hero_subtitle: "Jedes Stück wird einzeln an der Scheibe gedreht, glasiert und gebrannt. Keine zwei sind gleich – und genau das ist der Sinn.",
  hero_image: "https://images.unsplash.com/photo-1607556671927-78a6605e290b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",

  about_overline: "Über mich",
  about_heading: "Hallo, ich bin",
  about_name: "Mara.",
  about_p1: "Angefangen hat alles mit einem Volkshochschulkurs und dem Gefühl, dass Ton unter den Händen etwas mit einem macht. Aus der Neugier wurde eine Leidenschaft – und aus der Leidenschaft mein kleines Studio Tonpoesie in Merzig.",
  about_p2: "Ich arbeite bewusst in kleinen Serien, drehe jedes Stück selbst an der Scheibe und mische meine Glasuren von Hand. Mir ist wichtig, dass meine Keramik nicht in der Vitrine steht, sondern jeden Tag benutzt wird – zum Kaffee am Morgen, zum Essen mit Freunden.",
  about_p3: "Du findest mich regelmäßig auf regionalen Märkten und in ausgewählten Läden. Und wenn du selbst Lust hast, dich an die Scheibe zu setzen: In meinen Workshops zeige ich dir alles, was du für den Anfang brauchst.",
  about_image: "https://images.unsplash.com/photo-1668062286063-3ca609b3a252?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  about_badge_number: "12",
  about_badge_label: "Jahre an der Scheibe",
  about_stats: [
    { value: "500+", label: "Unikate getöpfert" },
    { value: "40+", label: "Workshops gehalten" },
    { value: "100%", label: "Handarbeit" },
  ],

  handwerk_overline: "Das Handwerk",
  handwerk_heading: "Drei Kapitel, von der ersten Berührung bis zum fertigen Stück.",
  chapters: [
    { n: "01", t: "Die Erde", d: "Alles beginnt mit einem Klumpen Ton. Ich arbeite mit Steinzeugmassen, die bei über 1200 °C gebrannt werden – robust genug für den täglichen Gebrauch." },
    { n: "02", t: "Die Scheibe", d: "An der Töpferscheibe wird jedes Gefäß frei gedreht. Der Rhythmus der Hände bestimmt Form und Charakter – ein Prozess, der Ruhe verlangt." },
    { n: "03", t: "Die Glasur", d: "Meine Salbei-Glasuren mische ich selbst. Feuer und Zufall geben jedem Stück seine eigene, unwiederholbare Oberfläche." },
  ],

  gallery_overline: "Die Werke",
  gallery_heading1: "Ausgewählte",
  gallery_heading_accent: "Unikate",
  gallery_intro: "Erhältlich auf Märkten, in ausgewählten Läden und auf Anfrage. Frag nach Verfügbarkeit oder einer Sonderanfertigung.",

  showcase_overline: "Impressionen",
  showcase_heading: "Ein Blick ins Regal",
  showcase_images: [
    "https://images.unsplash.com/photo-1633856858940-42229cb53dd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1605117012605-b68dedd4accc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1590422749897-47036da0b0ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.pexels.com/photos/7674568/pexels-photo-7674568.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/14341974/pexels-photo-14341974.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1633856859910-ab62d9cf10c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1530006498959-b7884e829a04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1610128361323-6e941c97f023?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  ],

  workshops_overline: "Workshops",
  workshops_heading: "Setz dich an die Scheibe. Mach dir die Hände schmutzig.",
  workshops_intro: "In kleinen Gruppen zeige ich dir das Töpfern von Grund auf. Kein Vorwissen nötig – nur Lust, etwas mit den eigenen Händen zu erschaffen.",

  maerkte_overline: "Unterwegs",
  maerkte_heading: "Nächste Märkte",
  maerkte_intro: "Hier findest du mich demnächst persönlich – komm vorbei und schau dir die Werke live an.",

  contact_overline: "Kontakt",
  contact_heading: "Schreib mir.",
  contact_accent: "Gerne.",
  contact_intro: "Bestellanfrage, Sonderanfertigung oder einfach eine Frage – ich melde mich persönlich zurück.",
  contact_email: "hallo@tonpoesie.de",
  contact_location: "Tonpoesie Keramik Studio, Merzig",
  contact_instagram: "@tonpoesie",
  contact_tiktok: "",
  tiktok_url: "",

  instagram_overline: "@tonpoesie",
  instagram_heading: "Frisch aus dem Studio",
  instagram_intro: "Neue Stücke, Prozess-Einblicke und Markttermine – folge mir für die neuesten Beiträge.",
  instagram_url: "https://instagram.com/tonpoesie",
  instagram_posts: [
    "https://images.unsplash.com/photo-1605117012605-b68dedd4accc?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1530006498959-b7884e829a04?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.pexels.com/photos/7674568/pexels-photo-7674568.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1590422749897-47036da0b0ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1633856858940-42229cb53dd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    "https://images.unsplash.com/photo-1610128361323-6e941c97f023?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ],

  footer_tagline: "Handgemacht in kleiner Kleinserie – für Menschen, die das Besondere im Alltäglichen suchen.",

  marquee_items: "Steinzeug · Handaufbau · Salbei-Glasur · Unikate · Töpferscheibe · Kleinserie",

  agb_text: "",

  impressum_text: "",
  datenschutz_text: "",
};
